import React, { useEffect, useState } from "react";
import * as S from "./Footer.styles";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

const Footer = () => {
  let location = useLocation();
  const [error, setError] = useState();
  const [logos, setLogos] = useState();

  const getLogos = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/v1/mklpayments/logos`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(),
        },
      );
      const data = await res.json();

      setLogos([data]);
    } catch (err) {
      return setError(err.message);
    }
  };

  useEffect(() => {
    getLogos();
  }, []);

  const checkLocation = () => {
    if (location.pathname === "/mklentryfee") {
      return [
        {
          office: "MKL",
          title: "Viešoji įstaiga Lietuvos moksleivių krepšinio lyga",
          code: "305956891",
          address: "Santakos g. 11, Kaunas, LT-44279",
          phone: "+370 650 15944",
          email: "info@mkl.lt",
          filePath: logos && logos[0] && logos[0][1] && logos[0][1].filePath,
          fileName: logos && logos[0] && logos[0][1] && logos[0][1].fileName,
        },
      ];
    }
    if (location.pathname === "/mklentryfee/success") {
      return [
        {
          office: "MKL",
          title: "Viešoji įstaiga Lietuvos moksleivių krepšinio lyga",
          code: "305956891",
          address: "Santakos g. 11, Kaunas, LT-44279",
          phone: "+370 650 15944",
          email: "info@mkl.lt",
          filePath: logos && logos[0] && logos[0][1] && logos[0][1].filePath,
          fileName: logos && logos[0] && logos[0][1] && logos[0][1].fileName,
        },
      ];
    }
    if (location.pathname === "/") {
      return [
        {
          office: "Asociacija „Lietuvos krepšinis“",
          title: "Asociacija „Lietuvos krepšinis“",
          code: "123921648",
          address: "Santakos g. 11, Kaunas, LT-44279",
          phone: "+370 37 78 77 95",
          email: "office@ltu.basketball",
          filePath: logos && logos[0] && logos[0][0] && logos[0][0].filePath,
          fileName: logos && logos[0] && logos[0][0] && logos[0][0].fileName,
        },
      ];
    }
    if (location.pathname === "/clublogin") {
      return [
        {
          office: "MKL",
          title: "Viešoji įstaiga Lietuvos moksleivių krepšinio lyga",
          code: "305956891",
          address: "Santakos g. 11, Kaunas, LT-44279",
          phone: "+370 650 15944",
          email: "info@mkl.lt",
          filePath: logos && logos[0] && logos[0][1] && logos[0][1].filePath,
          fileName: logos && logos[0] && logos[0][1] && logos[0][1].fileName,
        },
      ];
    }
    if (location.pathname === "/clublogin/account") {
      return [
        {
          office: "MKL",
          title: "Viešoji įstaiga Lietuvos moksleivių krepšinio lyga",
          code: "305956891",
          address: "Santakos g. 11, Kaunas, LT-44279",
          phone: "+370 650 15944",
          email: "info@mkl.lt",
          filePath: logos && logos[0] && logos[0][1] && logos[0][1].filePath,
          fileName: logos && logos[0] && logos[0][1] && logos[0][1].fileName,
        },
      ];
    }
    if (location.pathname === "/clublogin/account/selectedteam") {
      return [
        {
          office: "MKL",
          title: "Viešoji įstaiga Lietuvos moksleivių krepšinio lyga",
          code: "305956891",
          address: "Santakos g. 11, Kaunas, LT-44279",
          phone: "+370 650 15944",
          email: "info@mkl.lt",
          filePath: logos && logos[0] && logos[0][1] && logos[0][1].filePath,
          fileName: logos && logos[0] && logos[0][1] && logos[0][1].fileName,
        },
      ];
    }
    if (location.pathname === "/clublogin/forgotpassword") {
      return [
        {
          office: "MKL",
          title: "Viešoji įstaiga Lietuvos moksleivių krepšinio lyga",
          code: "305956891",
          address: "Santakos g. 11, Kaunas, LT-44279",
          phone: "+370 650 15944",
          email: "info@mkl.lt",
          filePath: logos && logos[0] && logos[0][1] && logos[0][1].filePath,
          fileName: logos && logos[0] && logos[0][1] && logos[0][1].fileName,
        },
      ];
    }
  };

  useEffect(() => {
    checkLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const currYear = new Date().getFullYear();

  return (
    <S.Footer className="has-background-white-ter mt-4 is-flex is-flex-direction-column">
      {error && (
        <div className="notification is-danger is-light">
          <button
            className="delete"
            onClick={() => {
              setError(null);
            }}
          ></button>
          <p className="subtitle is-7">{error}</p>
        </div>
      )}
      <div className="container footerContainer is-flex is-flex-wrap-wrap is-hidden-desktop">
        <p className="subtitle is-6 has-text-centered">
          <b>Kontaktai</b>
        </p>
        <figure className="image">
          <img
            src={checkLocation()[0].filePath}
            alt={checkLocation()[0].fileName}
          />
        </figure>
        <div className="content">
          <ul>
            <li>
              <p className="subtitle is-7">
                <b>Įstaiga: </b>
                {checkLocation()[0].title}
              </p>
            </li>
            <li>
              <p className="subtitle is-7">
                <b>Įmonės kodas: </b>
                {checkLocation()[0].code}
              </p>
            </li>
            <li>
              <p className="subtitle is-7">
                <b>Adresas: </b>
                {checkLocation()[0].address}
              </p>
            </li>
            <li>
              <p className="subtitle is-7">
                <b>Telefonas: </b>
                {checkLocation()[0].phone}
              </p>
            </li>
            <li>
              <Link
                to="#"
                onClick={(e) => {
                  window.location = "mailto:ofisas@mkl.lt";
                  e.preventDefault();
                }}
              >
                <p className="subtitle is-7">
                  <b>El. Paštas: </b>
                  <span className="has-text-link">
                    {checkLocation()[0].email}
                  </span>
                </p>
              </Link>
            </li>
          </ul>
        </div>
        <p className="subtitle is-6 has-text-centered">
          {checkLocation()[0].office} &copy; {currYear}
        </p>
      </div>
      <div className="container footerContainer is-flex is-flex-wrap-wrap is-hidden-touch">
        <figure className="image">
          <img
            src={checkLocation()[0].filePath}
            alt={checkLocation()[0].fileName}
          />
        </figure>
        <div className="content">
          <p className="subtitle is-6">
            <b>Kontaktai</b>
          </p>
          <ul>
            <li>
              <p className="subtitle is-7">
                <b>Įstaiga: </b>
                {checkLocation()[0].title}
              </p>
            </li>
            <li>
              <p className="subtitle is-7">
                <b>Įmonės kodas: </b>
                {checkLocation()[0].code}
              </p>
            </li>
            <li>
              <p className="subtitle is-7">
                <b>Adresas: </b>
                {checkLocation()[0].address}
              </p>
            </li>
            <li>
              <p className="subtitle is-7">
                <b>Telefonas: </b>
                {checkLocation()[0].phone}
              </p>
            </li>
            <li>
              <Link
                to="#"
                onClick={(e) => {
                  window.location = "mailto:ofisas@mkl.lt";
                  e.preventDefault();
                }}
              >
                <p className="subtitle is-7">
                  <b>El. Paštas: </b>
                  <span className="has-text-link">
                    {checkLocation()[0].email}
                  </span>
                </p>
              </Link>
            </li>
          </ul>
        </div>
        <p className="subtitle is-6 has-text-centered">
          {checkLocation()[0].office} &copy; {currYear}
        </p>
      </div>
    </S.Footer>
  );
};

export default Footer;
